import { FC } from 'react';

import { Action, ActionsList, ContentHeader } from 'components';
import { useTranslation } from 'libs/i18n';
import { ChipOrderStatus } from 'modules/order/common/components';

import { useOrderContext } from '../../providers/OrderProvider';
import { OrderFormTab } from '../../types';

import { useOrderFormHeader } from './useOrderFormHeader';

export interface OrderFormHeaderProps {
  title: string;
  tab: OrderFormTab;
}

export const OrderFormHeader: FC<OrderFormHeaderProps> = ({ title, tab }) => {
  const { t } = useTranslation();
  const { order } = useOrderContext();

  const { editable, actions, onClickOption } = useOrderFormHeader({ tab });

  return (
    <ContentHeader
      header={editable ? t('order.order.editTitle') : title}
      headerAfterContent={<ChipOrderStatus size="s" status={order.status} />}
      rightContent={
        !editable && actions.length > 0 ? (
          <ActionsList>
            {actions.map((action) => (
              <Action
                key={action.value}
                tooltip={action.label}
                onClick={() => onClickOption(action.value)}
              >
                <action.Icon color={action.color} size={16} />
              </Action>
            ))}
          </ActionsList>
        ) : null
      }
    />
  );
};
